import { render, staticRenderFns } from "./DocumentActivity.vue?vue&type=template&id=0e23ce46"
import script from "./DocumentActivity.vue?vue&type=script&lang=js"
export * from "./DocumentActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports